import { useEffect, useState } from "react";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { bustSocialLinksCache } from "@/lib/useSocialLinks";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const FIELDS = [
  { key: "instagram", label: "Instagram", Icon: Instagram, placeholder: "https://www.instagram.com/yourhandle" },
  { key: "youtube", label: "YouTube", Icon: Youtube, placeholder: "https://www.youtube.com/@yourchannel" },
  { key: "twitter", label: "X (Twitter)", Icon: Twitter, placeholder: "https://x.com/yourhandle" },
];

export default function AdminSocialLinks() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/social-links").then((r) => setForm(r.data)); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/admin/social-links", form);
      setForm(r.data);
      bustSocialLinksCache();
      toast.success("Social links saved");
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(Array.isArray(d) ? d[0]?.msg : d || "Could not save links");
    } finally {
      setSaving(false);
    }
  };

  if (!form) return <div className="text-sm text-slate-500">Loading…</div>;
  return (
    <div data-testid="admin-social-links-page" className="max-w-2xl">
      <h1 className="font-display font-black text-3xl text-slate-900">Social Links</h1>
      <p className="mt-2 text-sm text-slate-600">Shown on the landing page, member dashboard and welcome emails. Leave a field empty to hide that button.</p>
      <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 space-y-5">
        {FIELDS.map(({ key, label, Icon, placeholder }) => (
          <label key={key} className="block">
            <span className="flex items-center gap-2 text-xs uppercase tracking-widest text-slate-500 font-semibold"><Icon size={14} /> {label}</span>
            <Input
              data-testid={`admin-social-input-${key}`}
              className="mt-2"
              value={form[key] || ""}
              placeholder={placeholder}
              onChange={(e) => setForm({ ...form, [key]: e.target.value })}
            />
          </label>
        ))}
        <Button data-testid="admin-social-save-btn" onClick={save} disabled={saving}>{saving ? "Saving…" : "Save links"}</Button>
      </div>
    </div>
  );
}
